import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Icon } from 'loyal-react'
import IconItem from './IconItem'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

const ScheduledOrderItem = props => (
  <li className='pos-relative'>
    <div className='row align-items-center h-100 py-1'>
      <IconItem vendorId={props.vendorId} />
      <div className='col order-2'>
        <div className='row'>
          <div className='col order-1 order-md-1'>
            <p className='txt-subtitle'>
              {!props.hasCancel ? (
                <div>
                  Agendado em{' '}
                  {moment(props.scheduleDate)
                    .utc()
                    .format('DD/MM/YYYY [-] HH[:]mm')}
                </div>
              ) : (
                <div>Cancelado</div>
              )}
            </p>
            <p className='txt-body-sm mt-half'>
              <strong>{props.description}</strong>
            </p>
          </div>

          <div className='col-12 col-md-auto order-4 order-md-2 mt-1 mt-md-0'>
            <div className='row align-items-center h-100 px-0'>
              <div className='col-12'>
                <p className='txt-body-sm mt-half color-brand-1'>
                  <strong>
                    {' '}
                    <CatalogCurrencyLabel value={props.pointValue} />
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div className='col-auto order-2 order-md-3 d-none d-md-flex'>
            <div className='row align-items-center h-100 px-0'>
              <div className='col-12'>
                {props.editable && !props.hasCancel ? (
                  <Icon
                    iconName='icon_edit'
                    className='icon-sm'
                    onClick={e => props.onEdit(props.index)}
                  />
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
          <div className='col-auto order-3 order-md-4'>
            <div className='row align-items-center h-100 px-0'>
              <div className='col-12'>
                {props.editable && !props.hasCancel ? (
                  <Icon
                    iconName='icon_trash'
                    className='icon-sm'
                    onClick={e => props.onDelete(props.index)}
                  />
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
)

ScheduledOrderItem.propTypes = {
  scheduleDate: PropTypes.objectOf(typeof Date),
  description: PropTypes.string,
  pointValue: PropTypes.number,
  vendorId: PropTypes.number,
  editable: PropTypes.bool,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  index: PropTypes.number,
  hasCancel: PropTypes.bool
}

export default ScheduledOrderItem



// WEBPACK FOOTER //
// ./src/Participant/Scheduling/ScheduledOrderList/ScheduleOrderItem/ScheduleOrderItem.js